import { sendToApi } from 'api/client'
import { ExternalIntegrationEnum } from './ExternalIntegrationsClient'

export interface IntegrationAuth {
  id: number
  provider: ExternalIntegrationEnum
  created_at: string
  updated_at: string
  access_token: string
}

export type ConnectableAccount = {
  provider_id: string
  provider: ExternalIntegrationEnum
  name: string
  picture: string
  additional_data: any
  account_type: 'page' | 'profile' | 'ad_account' | 'analytics' | 'drive'
}

export class IntegrationAuthError extends Error {
  errorCode?: string

  constructor(message: string, errorCode?: string) {
    super(message)
    this.name = 'IntegrationAuthError'
    this.errorCode = errorCode
  }
}

export const IntegrationAuthsClient = {
  create: async ({
    workspaceId,
    provider,
    params,
  }: {
    workspaceId: number
    params: any
    provider: ExternalIntegrationEnum
  }) => {
    return sendToApi<IntegrationAuth>(`/w/${workspaceId}/integration_auths?provider=${provider}`, {
      method: 'POST',
      body: params,
    })
  },
  connectableAccounts: async ({
    workspaceId,
    integrationAuthId,
  }: {
    workspaceId: number
    integrationAuthId: number
  }) => {
    return sendToApi<{ data: ConnectableAccount[]; metadata: any }>(
      `/w/${workspaceId}/integration_auths/${integrationAuthId}/connectable_accounts`,
    )
  },
}
